import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getRows = store => store[NAME].rows;
export const getTurnList = store => store[NAME].turnList;
export const getSchedulesList = store => store[NAME].schedulesList;